import { Header } from "./index"

export default function Layout ({ children }) {
  return (
    <div className="min-h-screen bg-gray-900">
      <div className="relative overflow-none">
        <Header/>
        <main>{children}</main>
      </div>
    </div>
  )
}